export default __webpack_public_path__ + "static/media/scroll.673577c8.svg";